import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem } from '@marriott/mi-ui-library';
import { constants } from '../../../modules';

export const StyledStepOne = styled.div`
  ${rtl`
  .radio-button-yes:is(${constants.RTL_LANG_LIST}) {
    padding: 0 0 0 ${toRem(32)} !important;
    margin: 0 0 0 ${toRem(16)} !important;
  }`}
`;
